import _ from "lodash";
import React from "react";
import InlineMoreItemsWithTooltip from "UIComponents/InlineMoreItemsWithTooltip";
import classes from "./ErrorCell.scss";

const ErrorCell = ({ columnData }) => {
  return (
    <div className={classes.wrapper}>
      {_.map(columnData, ({ gradeLevels, errorMessage, key }) => {
        return (
          <div className={classes.container} key={key}>
            <span>
              <InlineMoreItemsWithTooltip
                items={gradeLevels}
                length={_.size(gradeLevels) > 2 ? 1 : 2}
                customClass="text-body"
                toolTipItemTextClass="text-body"
                moreJoinSymbol=" +"
              />
              {errorMessage}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ErrorCell;
